import { z } from 'zod';

const NAME_MIN_LENGTH = 1;
const NAME_MAX_LENGTH = 1024;

const ADDRESS_MIN_LENGTH = 1;
const ADDRESS_MAX_LENGTH = 1024;

const PHONE_MIN_LENGTH = 1;
const PHONE_MAX_LENGTH = 255;

const EMAIL_MIN_LENGTH = 1;
const EMAIL_MAX_LENGTH = 255;

const WEBSITE_MIN_LENGTH = 1;
const WEBSITE_MAX_LENGTH = 255;

const NAME_ALLOW_CHARACTERS = /^[a-zA-Z0-9\u0E00-\u0E3A\u0E40-\u0E4E_\-:,()\s]+$/;
const ALLOW_URL_PATTERN =
  /^https?:\/\/(?:(?:www\.([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.)|(?:([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.)*([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.)[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?(?::[0-9]{1,5})?(?:\/[^\s]*)?$/;

const emailSchema = (requiredMessage: string) =>
  z
    .string()
    .trim()
    .min(EMAIL_MIN_LENGTH, { message: requiredMessage })
    .max(EMAIL_MAX_LENGTH, { message: `อีเมลต้องมีความยาวไม่เกิน ${EMAIL_MAX_LENGTH} ตัวอักษร` })
    .email({ message: 'กรุณากรอกอีเมลที่ถูกต้อง' })
    .regex(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, {
      message: 'กรุณากรอกอีเมลให้ถูกต้อง',
    });

export const ExamCenterDetailsFormSchema = z.object({
  nameTH: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, { message: 'กรุณากรอก ชื่อศูนย์ทดสอบ (ภาษาไทย)' })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อศูนย์สอบต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(NAME_ALLOW_CHARACTERS, {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () เท่านั้น',
    }),
  addressTH: z
    .string()
    .trim()
    .min(ADDRESS_MIN_LENGTH, { message: 'กรุณากรอกที่อยู่' })
    .max(ADDRESS_MAX_LENGTH, {
      message: `ที่อยู่ต้องมีความยาวไม่เกิน ${ADDRESS_MAX_LENGTH} ตัวอักษร`,
    }),
  phoneTH: z
    .string()
    .trim()
    .min(PHONE_MIN_LENGTH, { message: 'กรุณากรอกเบอร์โทรศัพท์' })
    .max(PHONE_MAX_LENGTH, {
      message: `เบอร์โทรศัพท์ต้องมีความยาวไม่เกิน ${PHONE_MAX_LENGTH} ตัวอักษร`,
    }),
  nameEN: z
    .string()
    .trim()
    .min(NAME_MIN_LENGTH, { message: 'กรุณากรอก ชื่อศูนย์ทดสอบ (ภาษาอังกฤษ)' })
    .max(NAME_MAX_LENGTH, {
      message: `ชื่อศูนย์สอบต้องมีความยาวไม่เกิน ${NAME_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(NAME_ALLOW_CHARACTERS, {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () เท่านั้น',
    }),
  addressEN: z
    .string()
    .trim()
    .min(ADDRESS_MIN_LENGTH, { message: 'กรุณากรอกที่อยู่' })
    .max(ADDRESS_MAX_LENGTH, {
      message: `ที่อยู่ต้องมีความยาวไม่เกิน ${ADDRESS_MAX_LENGTH} ตัวอักษร`,
    }),
  phoneEN: z
    .string()
    .trim()
    .min(PHONE_MIN_LENGTH, { message: 'กรุณากรอกเบอร์โทรศัพท์' })
    .max(PHONE_MAX_LENGTH, {
      message: `เบอร์โทรศัพท์ต้องมีความยาวไม่เกิน ${PHONE_MAX_LENGTH} ตัวอักษร`,
    }),
  website: z
    .string()
    .trim()
    .min(WEBSITE_MIN_LENGTH, { message: 'กรุณากรอกชื่อเว็บไซต์' })
    .max(WEBSITE_MAX_LENGTH, {
      message: `ชื่อเว็บไซต์ต้องมีความยาวไม่เกิน ${WEBSITE_MAX_LENGTH} ตัวอักษร`,
    })
    .regex(ALLOW_URL_PATTERN, {
      message: 'รูปแบบ URL ไม่ถูกต้อง กรุณากรอกลิงก์ที่ขึ้นต้นด้วย http:// หรือ https://',
    }),
  email: emailSchema('กรุณากรอกอีเมล'),
  examResultRecipientEmail: emailSchema('กรุณากรอกอีเมลรับผลการสอบ'),
});

export type ExamCenterDetailsFormInput = z.infer<typeof ExamCenterDetailsFormSchema>;
